import { createContext } from "react";

// Pure context object (no components here to satisfy react-refresh rule)
export const RealtimeContext = createContext({
  client: null,
  connected: false,
  on: () => undefined,
  off: () => undefined,
  emit: () => false,
  wsEnabled: false, // Whether WebSocket is enabled in settings
});
